import { gxGetMandateDetails } from "@/app/apiConfig/services/accountsAbstractApiLayer";
import type { MandateDetails } from "@/app/types/accounts";
import { useEffect, useState, type Dispatch, type SetStateAction } from "react";

interface UseMandateDetails {
  directDebitId: number;
  setIsMandateDetailsLoading: Dispatch<SetStateAction<boolean>>;
}
export const useMandateDetails = ({
  directDebitId,
  setIsMandateDetailsLoading,
}: UseMandateDetails) => {
  const [mandateDetails, setMandateDetails] = useState<MandateDetails>();

  const getMandateDetails = async () => {
    try {
      setIsMandateDetailsLoading(true);
      const payload = {
        directDebitId: directDebitId,
      };
      const result = await gxGetMandateDetails(payload);
      if (result?.data) {
        setMandateDetails(result?.data);
      }
    } catch (err) {
      console.log("Error in getMandateDetails::", err);
    } finally {
      setIsMandateDetailsLoading(false);
    }
  };

  useEffect(() => {
    getMandateDetails();
  }, []);

  return { mandateDetails };
};
